// extracted by mini-css-extract-plugin
module.exports = {"root":"gallery-item_root__XhN6F","media":"gallery-item_media__fws5c","video":"gallery-item_video__o_xx_"};